var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 593,
    height: 219,
    viewBox: "0 0 593 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.137 213.692C80.2373 213.692 54.0712 201.976 35.1299 183.034C16.1886 164.096 4.47211 137.93 4.47211 109.027C4.47211 80.128 16.1886 53.9618 35.1299 35.0205C54.0712 16.0792 80.2373 4.36273 109.137 4.36273C129.633 4.36273 148.754 10.2563 164.897 20.4412L158.391 28.4613C156.636 30.6261 155.328 32.9234 154.453 35.3916C154.244 35.9777 154.062 36.5727 153.903 37.1706C140.917 29.0621 125.575 24.3791 109.137 24.3791C85.7627 24.3791 64.5977 33.8542 49.2791 49.1698C33.9635 64.4883 24.4885 85.6534 24.4885 109.027C24.4885 132.404 33.9635 153.566 49.2791 168.885C64.5977 184.201 85.7627 193.676 109.137 193.676C132.514 193.676 153.676 184.201 168.994 168.885C184.31 153.566 193.785 132.404 193.785 109.027C193.785 92.5925 189.102 77.2474 180.994 64.2616C181.591 64.1025 182.183 63.9199 182.772 63.7108C185.241 62.836 187.538 61.5283 189.703 59.7729L197.723 53.2667C207.908 69.41 213.801 88.5309 213.801 109.027C213.801 137.93 202.085 164.093 183.144 183.034C164.202 201.976 138.039 213.692 109.137 213.692Z",
    fill: "#6699FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.137 138.766C100.925 138.766 93.4883 135.438 88.1073 130.057C82.7262 124.673 79.395 117.239 79.395 109.027C79.395 100.816 82.7262 93.3818 88.1073 87.9978C93.4883 82.6167 100.925 79.2856 109.137 79.2856C112.409 79.2856 115.558 79.8157 118.503 80.7936L99.703 99.5935C94.4927 104.804 94.4927 113.251 99.703 118.461C104.913 123.671 113.36 123.671 118.571 118.461L137.371 99.6613C138.348 102.607 138.876 105.755 138.876 109.027C138.876 117.239 135.547 124.673 130.166 130.057C124.782 135.438 117.348 138.766 109.137 138.766Z",
    fill: "#6699FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.137 175.745C90.7138 175.745 74.0345 168.278 61.9616 156.202C49.8859 144.13 42.4195 127.45 42.4195 109.027C42.4195 90.6044 49.8859 73.9251 61.9616 61.8523C74.0345 49.7765 90.7138 42.3101 109.137 42.3101C122.735 42.3101 135.382 46.3776 145.93 53.3639L132.584 66.7091C125.639 62.8537 117.643 60.6565 109.137 60.6565C95.7797 60.6565 83.6863 66.07 74.9328 74.8234C66.1793 83.5769 60.7658 95.6704 60.7658 109.027C60.7658 122.384 66.1793 134.478 74.9328 143.231C83.6863 151.985 95.7797 157.398 109.137 157.398C122.494 157.398 134.587 151.985 143.341 143.231C152.094 134.478 157.508 122.384 157.508 109.027C157.508 100.518 155.31 92.5248 151.455 85.5797L164.8 72.2345C171.786 82.7817 175.854 95.4288 175.854 109.027C175.854 127.45 168.388 144.13 156.312 156.202C144.239 168.278 127.56 175.745 109.137 175.745Z",
    fill: "#6699FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.407 8.9103V26.4202C188.407 28.2581 189.906 29.7572 191.744 29.7572H209.254C209.908 29.7572 210.461 30.1489 210.679 30.7616C210.894 31.3742 210.712 32.0281 210.205 32.4375L184.457 53.3227C181.656 55.5965 178.555 56.6951 174.944 56.6951H174.022H169.725L113.263 113.154C110.986 115.433 107.287 115.433 105.01 113.154C102.731 110.877 102.731 107.178 105.01 104.901L161.469 48.4393V44.1421V43.2202C161.469 39.6093 162.568 36.5079 164.841 33.7069L185.727 7.95896C186.136 7.45237 186.787 7.26976 187.403 7.48477C188.015 7.70272 188.407 8.25644 188.407 8.9103Z",
    fill: "#6699FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.54 189.107C178.805 187.196 181.011 185.173 183.147 183.037C185.303 180.881 187.344 178.652 189.273 176.363L124.971 112.061L118.571 118.461C116.132 120.903 112.98 122.199 109.785 122.352L176.54 189.107Z",
    fill: "#6699FF",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.137,
    cy: 109.027,
    rx: 104.667,
    ry: 104.667,
    fill: "url(#paint0_linear_12_13447)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.137,
    cy: 109.027,
    rx: 104.667,
    ry: 104.667,
    fill: "url(#paint1_linear_12_13447)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M304.395 161.484H328.286L363.937 72.0059H340.232L316.527 137.25H316.154L292.635 72.0059H268.184L304.395 161.484Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M362.761 116.372C362.761 144.52 384.413 164.094 411.478 164.094C438.542 164.094 460.194 144.52 460.194 116.372C460.194 88.2238 438.542 69.3961 411.478 69.3961C384.413 69.3961 362.761 88.2238 362.761 116.372ZM385.533 116.372C385.533 102.391 393.745 87.6645 411.478 87.6645C429.21 87.6645 437.423 102.391 437.423 116.372C437.423 130.353 429.21 145.452 411.478 145.452C393.745 145.452 385.533 130.353 385.533 116.372Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M497.591 161.484L493.111 172.855C489.378 182.175 486.765 186.836 477.246 186.836C474.819 186.836 471.833 186.463 468.846 185.531L466.98 204.918C470.899 205.85 474.819 206.223 478.552 206.223C498.338 206.223 506.177 196.902 512.523 180.684L554.894 72.0059H531.562L509.35 137.064H508.977L483.965 72.0059H459.14L497.591 161.484Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M588.435 29.5039H566.036V120.1H588.435V29.5039ZM562.303 148.435C562.303 156.451 569.396 162.602 577.236 162.602C585.448 162.602 592.168 156.078 592.168 148.062C592.168 140.046 585.262 133.895 577.236 133.895C569.023 133.895 562.303 140.419 562.303 148.435Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_13447",
    x1: 213.804,
    y1: 213.694,
    x2: 109.137,
    y2: 109.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADC5FF",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADC5FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_13447",
    x1: 4.4697,
    y1: 4.36029,
    x2: 109.137,
    y2: 109.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a73b15a2f37684f609394947d7e4492e.svg";
export { ForwardRef as ReactComponent };